import React from "react";
import PropTypes from "prop-types";
import AssetUploader from "./components/AssetUploader";
import MultiAssetUploader from "./components/MultiAssetUploader/MultiAssetUploader";
import VideoUploader from "./components/VideoUploader";
import Checkbox from "./components/Checkbox/Checkbox";
import CheckboxGroup from "./components/CheckboxGroup";
import Currency from "./components/Currency";
import ImageCropper from "./components/ImageCrop";
import Radio from "./components/Radio";
import Select from "./components/Select";
import CardSelect from "./components/CardSelect/CardSelect";
import Submit from "./components/Submit";
import TextInput from "./components/TextInput";
import Textarea from "./components/Textarea";
import Wysiwyg from "./components/Wysiwyg";
import FormInputTranslator from "./utilities/FormInputTranslator";

const components = {
  checkbox: Checkbox,
  checkboxGroup: CheckboxGroup,
  currency: Currency,
  imageCropper: ImageCropper,
  imageUploader: AssetUploader,
  multiImageUploader: MultiAssetUploader,
  videoUploader: VideoUploader,
  radio: Radio,
  select: Select,
  cardSelect: CardSelect,
  submit: Submit,
  text: TextInput,
  password: TextInput,
  textarea: Textarea,
  wysiwyg: Wysiwyg,
};

const FormInput = (props) => {
  const inputType = props.type;
  const FormInputType = components[inputType];
  const FormInputTranslated = FormInputTranslator(props);
  return <FormInputType {...FormInputTranslated} key={`form-input_${props.name}`} />;
};

FormInput.propTypes = {
  type: PropTypes.oneOf(Object.keys(components)).isRequired,
  name: PropTypes.string,
};

export default FormInput;
